var isObject = require('../internals/is-object');

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/an-object.js
// module id = 14
// module chunks = 3